import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { EmployeeAddress, EmployeeAddressCreate, EmployeeAddressFilter } from '../data/employeeAddress';

export function createEmployeeAddressService(client: AxiosInstance) {
  return createCrudService<EmployeeAddress, EmployeeAddressCreate, EmployeeAddressFilter>(
    client,
    '/hrm/EmployeeAddress',
    'id',
  );
}

export type EmployeeAddressService = CrudService<EmployeeAddress, EmployeeAddressCreate, EmployeeAddressFilter>;
